module.exports = __webpack_public_path__ + "img/timer-event.033a68f5.svg";